import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RequirePermission from "components/util-components/RequirePermission";
import { PERMISSIONS } from "functions/permissions";
import Orders from "./orders";
import Exact from "./exact";
import PurchaseOrders from "../purchase-orders/purchase-orders";
import PurchaseOrderDetail from "../purchase-orders/detail";

const PARENT_URL = "/cms/orders";

// De groep zit al achter ORDERS_VIEW (app-views/index.js). Exact en de
// inkooporder-detailroutes die hier historisch onder hangen zijn beheer.
const Bestellingen = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<Orders />} />
      <Route
        path={`/exact`}
        element={
          <RequirePermission permission={PERMISSIONS.ORDERS_EXACT}>
            <Exact />
          </RequirePermission>
        }
      />
      <Route
        path={`/purchase-orders`}
        element={
          <RequirePermission permission={PERMISSIONS.PURCHASING_MANAGE}>
            <PurchaseOrders />
          </RequirePermission>
        }
      />
      <Route
        path={`/purchase-orders/:id`}
        element={
          <RequirePermission permission={PERMISSIONS.PURCHASING_MANAGE}>
            <PurchaseOrderDetail />
          </RequirePermission>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default Bestellingen;
